<template>
  <div class="purchase-cargo-insurance-loading-skeleton">
    <Skeleton class="mb-3" width="20rem" height="1.5rem" />

    <Skeleton class="mb-3" width="100%" height="5rem" />

    <Skeleton class="mb-1" width="100%" height="1.5rem" />
    <Skeleton class="mb-3" width="75%" height="1.5rem" />

    <Skeleton class="mb-1" width="100%" height="1.5rem" />
    <Skeleton class="mb-3" width="75%" height="1.5rem" />

    <Skeleton class="mb-1" width="100%" height="1.5rem" />
    <Skeleton class="mb-3" width="75%" height="1.5rem" />

    <Skeleton class="mb-3" width="10rem" height="1.5rem" />
    <Skeleton class="mb-3" width="100%" height="10rem" />
  </div>
</template>

<script setup lang="ts">
import Skeleton from 'primevue/skeleton';
</script>
